export const cellRowGap = 8;

export const baseLineHeight = 1;
export const progressLineHeight = 4;
export const pointerSize = 8;

export const barChartHeight = Math.max(baseLineHeight, progressLineHeight, pointerSize);
